module.exports = __webpack_public_path__ + "img/voice.154ce491.svg";